<template>
	<div class="qiandaoBox">
		<!-- 头部 -->
		<div class='bannerimg'>
			<div class="arrImg" @click="back">
				<img src="../../assets/img/leftarr.png" alt="">
			</div>
			<img class="ljqd" src="../../assets/img/ljqd.png" @click="showdiv(today)" alt="" />
			<div class="yjbNumBox">
				<div class="yjbNumBox_left">
					<span class="qdtxt">签到</span>
					<span>明日签到可得1幸运值</span>
				</div>
				<!-- <div class="yjbNumBox_right">
					<img src="../../assets/img/moneyIcon.png" alt="" />
					<span><i>{{signinData.user_money}}</i>云锦币</span>
				</div> -->
			</div>
			<div class="qdbox">
				<!-- :style="styleObject" -->
				<div class="qdicon">
					<div class="qdline" v-for="(value, key) in day_list">
						<!--  -->
						<img src="../../assets/img/qdicon_active.png" v-if="value.status == 1 ?true : false" alt="">
						<img src="../../assets/img/qdicon.png" alt="" v-if="value.status != 1 ?true : false">
						<p>第{{value.day.replace(/^0+/,"")}}天</p>
					</div>
				</div>
			</div>
			<div class="myXyz_num">
				<p>我的幸运值</p>
				<p ref="xyvalueTxt">{{signinData.user_lucky_score}}</p>
			</div>
		</div>
		<!-- 签到 -->
		<div class="calendar_box">
			<div class="qdDataIconBox">
				<img src="../../assets/img/qdDataIcon.png" alt="" class="qdDataIconLeft">
				<img src="../../assets/img/qdDataIcon.png" alt="" class="qdDataIconRight">
			</div>
			<div class="calendar">
				<div class="ym">
					<!--后一个月按钮-->
					<span class="prev" @click="prevMonth"><img src="../../assets/img/qdDataLeft.png" alt=""></span>
					<!-- 今天的年/月，如图显示的2019年11月 -->
					<span class="currentData">{{ year }}-{{ month }}-{{today}}</span>
					<!--前一个月按钮-->
					<span class="next" @click="nextMonth"><img src="../../assets/img/qdDataRight.png" alt=""></span>
				</div>
				<ul class="thead">
					<li>日</li>
					<li>一</li>
					<li>二</li>
					<li>三</li>
					<li>四</li>
					<li>五</li>
					<li>六</li>
				</ul>
				<ul id="data">
					<li v-for="(value, key) in day_list" :key="key">
						<!--展示日期-->
						<!-- <span class="day">{{ value }}</span> -->
						<!-- @click="dayCheck(value)" -->
						<span  v-if="value == '' ? false : true"  :class="value.status == 1 ? 'activeData' : 'day'">{{ value.day.replace(/^0+/,"") }}</span>
						<!-- <span class="pro" v-if="showProgrssStatus(value) === 0">{{ '休' }}</span> -->
					</li>
				</ul>
			</div>
		</div>

		<van-overlay :show="show">
			<div class="wrapper" @click="hidden">
				<div class="tostBox ">
					<div class="tostBox_info">
						<h4>幸运值</h4>
						<p>签到成功获得 1 个幸运值<br />您的幸运值正在加速成长哦~</p>
					</div>
				</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import {Toast} from 'vant';
	export default {
		data() {
			return {
				year: '', // 当前年份
				month: '', // 当前月份
				today: 0, // 当前日期
				calList: [], // 日历数组
				progressData: [], // 日历中的特殊表识
				show: false,
				activeVlueData: '',
				yqdTxt:'',
				signinData:{},
				day_list:[],
				msgState:'',
				styleObject: '',
			};
		},
		created() {
			this.signin_page();
			this.getCalendar();
		},
		mounted() {
			
			// this.xyvalueFn(); //数字自增
		},
		methods: {
			signin_page(){
				var date = new Date();
				this.year = date.getFullYear();
				this.month = date.getMonth() + 1;
				this.today = date.getDate();
				this.$axios.post(this.$api.signin_page,{
					month: this.year + '-' +this.month
				}).then(res => {
					console.log(res)
					this.signinData=res.data.data;
					this.day_list = res.data.data.day_list;
					// for(var i= 0;i<this.day_list.length;i++){
					// 	console.log(this.day_list[i])
					// }
					// for(var i in this.day_list){
					// 	console.log(this.day_list[i],this.day_list[i].day.replace(/^0+/,""))
					// 	if(this.day_list[i].status == 1){
					// 		this.styleObject = {
					// 			'-webkit-transform': 'translateX(-' + 28 * 1 + '%' + ')',
					// 			transitionDuration: '0s'
					// 		};
					// 	}
					// }
					// this.day_list.forEach(item => {
					// 	console.log(item,'item---------------00')
					// })
				})
			},
			getCalendar(cYear, cMonth) {
				let calendarArr = [];
				let myDate = new Date();
				let year = cYear || this.year ? this.year : myDate.getFullYear();
				let month = cMonth || this.month ? this.month : (myDate.getMonth() + 1);
				let today = myDate.getDate();

				this.year = year;
				this.month = month;
				this.today = today;

				let buweinum = 1

				// 获取上一个月的最后一天start
				var day = new Date(myDate.getFullYear(), myDate.getMonth(), 0).getDate(); //获取上一个月的最后一天
				var enddate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, day); //获取上一个月的日期
				console.log(day, 'lastDay')


				let firstday = new Date(year, (month - 1), 1).getDay(); //当月第一天是周几
				let days = new Date(year, month, 0).getDate(); //当月有多少天+1

				var prevLastday = '';
				if (day == 30) {
					prevLastday = day - firstday + 1;
					// for(let i = prevLastday; i>prevLastday; i-- ){
					// 	console.log(i,'11')
					// }
				} else if (day == 31) {
					prevLastday = day - firstday + 2;
				}
				console.log(day, prevLastday, firstday, 'prevLastday')
				for (let i = 0; i < days; i++) {
					calendarArr[i] = i + 1;
				}

				for (let j = 0; j < firstday; j++) { // 日 一 二 三 四 五 六         当月首日前位置补‘’
					calendarArr.unshift('');
				}
				// 获取日历的行数  
				let len = calendarArr.length;
				let line = Math.ceil(len / 7);

				for (let k = 0; k < line * 7 - len; k++) { // 日 一 二 三 四 五 六         当月最后一日后位置补‘’
					calendarArr.push('');
				}
				this.calList = calendarArr;
				//   '' ''  ''  ''   ''  ''  1          当月首日前位置补‘’
				//   2   3   4   5   6   7   8 
				//   9   10  11  12  13  14  15
				//   16  17  18  19  20  21  22
				//   23  24  25  26  27  28  29 
				//   30  31  ''  ''  ''  ''  ''         当月最后一日后位置补‘’
				// 调用接口，获取需要显示的数据
				// eg：2019年11月7日休息，status为0的才会显示
				this.progressData = [{
					day: 7,
					month: 11,
					year: 2019,
					status: 0
				}];
			},
			// 上一个月按钮点击
			prevMonth() {
				this.progressData = [];
				this.month--;
				if (this.month < 1) {
					this.month = 12;
					this.year--;
				}
				this.getCalendar(this.year, this.month);
				
				this.$axios.post(this.$api.signin_page,{
					month: this.year + '-' +this.month
				}).then(res => {
					console.log(res)
					this.signinData=res.data.data;
					this.day_list = res.data.data.day_list;
				})
			},
			// 下一个月按钮点击
			nextMonth() {
				this.progressData = [];
				this.month++;
				if (this.month > 12) {
					this.month = 1;
					this.year++;
				}
				this.getCalendar(this.year, this.month);
				this.$axios.post(this.$api.signin_page,{
					month: this.year + '-' +this.month
				}).then(res => {
					console.log(res)
					this.signinData=res.data.data;
					this.day_list = res.data.data.day_list;
				})
			},
			/**
			 * 点击日期查询
			 * @param index
			 */
			// dayCheck(day) {
			// 	console.log('day', day);
			// 	this.activeVlueData = date.getDate();
			// 	var date = new Date();
			// 	this.year = date.getFullYear();
			// 	this.month = date.getMonth() + 1;
			// 	this.today = date.getDate();
			// },
			// 计算日历中每日任务的状态
			showProgrssStatus(value) {
				for (let item in this.progressData) {
					if (this.progressData[item].day === value && this.progressData[item].month === this.month && this.progressData[
							item].year === this.year) {
						if (this.progressData[item].done_time >= this.progressData[item].all_time) {
							return 1;
						} else {
							return this.progressData[item].status;
						}
					}
				}
			},

			//签到弹框
			showdiv(showdiv) {
				// if(localStorage.getItem('yqdTxt') == undefined){
					if(this.msgState != '已签到'){
						this.$axios.post(this.$api.signin).then(res => {
							// localStorage.setItem('yqdTxt',res.data.msg);
							var date = new Date();
							this.year = date.getFullYear();
							this.month = date.getMonth() + 1;
							this.today = date.getDate();
							this.activeVlueData = date.getDate();
							this.show = !this.show;
							Toast(res.data.msg);
							this.msgState= res.data.msg;
							this.signin_page();
						})
					}else{
						Toast('今日已签到！')
					}
					
				// }else {
				// 	Toast('今日已签到！')
				// 	this.signin_page();
				// 	// this.$router.push('/userinfo')
				// }
				
			},
			hidden() {
				this.show = !this.show
			},
			back() {
				this.$router.push('/userinfo')
			},
			xyvalueFn() {
				let num = 0
				let that = this;
				let terval = setInterval(function() {
					num++;
					let xyTxt = that.$refs.xyvalueTxt;
					xyTxt.innerText= num;
					if (num == that.xyValue) {
						clearInterval(terval);
					}
				}, 100);
			},

		}
	};
</script>


<style>
	.van-overlay {
		background-color: rgba(124, 124, 124, .7);
	}
</style>
<style lang="less" scoped>
	.qiandaoBox {
		height: 100vh;
		background-color: #f9f9f9;
		overflow: hidden;

		//背景图
		.bannerimg {
			width: 100vw;
			height: 544px;
			background-color: #25cede;
			border-bottom-left-radius: 90px;
			border-bottom-right-radius: 90px;
			position: fixed;
			top: 0;

			.arrImg {
				img {
					position: fixed;
					top: 60px;
					left: 0px;
					width: 50px;
				}
			}

			.ljqd {
				position: absolute;
				bottom: -70px;
				left: 50%;
				transform: translateX(-50%);
				width: 60%;
			}

			.yjbNumBox {
				padding-top: 140px;
				margin: 0 34px;
				line-height: 60px;
				overflow: hidden;

				.yjbNumBox_left {
					width: 52%;
					text-align: left;
					float: left;

					span {
						padding-right: 20px;
						color: #bdf0f5;
						font-size: 22px;
						/*px*/
					}

					.qdtxt {
						font-size: 36px;
						/*px*/
						color: #fff;
					}
				}

				.yjbNumBox_right {
					float: right;
					background-color: #fff;
					// margin-left: 40px;
					padding: 0 10px;
					padding-right: 15px;
					position: relative;
					border-radius: 60px;

					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
					}

					span {
						padding-left: 45px;
						font-size: 22px;
						/*px*/
						color: #25cede;

						i {
							font-style: normal;
						}
					}
				}
			}

			.qdbox{
				width: 100vw;
				height: 130px;
				overflow: scroll;
				.qdicon {
					width: 3360px;
					height: 130px;
					display: flex;
					justify-content: space-around;
					padding-top: 30px;
					text-align: center;
					
					div {
						position: relative;
						img {
							width: 60px;
						}
				
						p {
							color: #fff;
						}
					}
					div.qdline::after{
						content: "";
						width: 60px;
						height: 4px;/*px*/
						background-color: #bdf0f5;
						position: absolute;
						left: 60px;
						top: 25%;
						transform: translateY(-50%);
						margin-top: -2px;
						z-index: 2;
					}
					div.qdline:last-of-type::after {
						width:0;
					}
				
				}
			}
			.mol{ width: 100%; height: 52rpx; position: relative;  }
			.mol .mol-line{ width: 100%; height: 4rpx; background-color: #e6e6e6; position: absolute; left: 0; top: 50%; transform: translateY(-50%);}
			.mol .mol-ites{ width: 100%; height: 100%;position: absolute;}
			.mol-ites .ite{ width: 52rpx; height: 52rpx; border-radius: 50%; border: 1px solid #f5f5f5;
			 background-color: #fff; box-sizing: border-box;  position: absolute; left: 0; top: 0; z-index: 2;}
			.mol-ites .ite .n{ width: 44rpx; height: 44rpx; line-height: 44rpx; text-align: center; border-radius: 50%; background-color: #f5f5f5;position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); font-size: 22rpx;}
			.mol-ites .ite::after{ content: ""; width: 80rpx; height: 4rpx; background-color: transparent; 
			position: absolute; left: 52rpx; top: 50%; margin-top: -2rpx; z-index: 2;}
			.mol-ites .ite:last-of-type::after{ width: 0;}
			.mol-ites .ite:nth-of-type(2){ left: 107rpx;}
			.mol-ites .ite:nth-of-type(3){ left: 214rpx;}
			.mol-ites .ite:nth-of-type(4){ left: 321rpx;}
			.mol-ites .ite:nth-of-type(5){ left: 428rpx;}
			.mol-ites .ite:nth-of-type(6){ left: 535rpx;}
			.mol-ites .ite:nth-of-type(7){ left: 642rpx;}
			.mol-ites .ite.hover{ border-color: #ff614a;}
			.mol-ites .ite.hover .n{ background-color: #ff614a; color: #fff;}
			.mol-ites .ite.hover::after{ background-color: #ff614a; }
			.moday{ width: 100%; height:40rpx; overflow: hidden; position: relative; margin-top:20rpx;}
			.moday .dd{ width: 52rpx; height: 40rpx; line-height: 1; text-align: center; font-size: 22rpx;
			 position: absolute; left: 0; bottom: 0;}
			.moday .dd:nth-of-type(2){ left: 107rpx;}
			.moday .dd:nth-of-type(3){ left: 214rpx;}
			.moday .dd:nth-of-type(4){ left: 321rpx;}
			.moday .dd:nth-of-type(5){ left: 428rpx;}
			.moday .dd:nth-of-type(6){ left: 535rpx;}
			.moday .dd:nth-of-type(7){ left: 642rpx;}

			.myXyz_num {
				margin-top: 30px;

				p {
					line-height: 60px;
					text-align: center;
					color: #fff;
					font-weight: 500;
					font-size: 40px;
					/*px*/
				}
			}
		}

		.calendar_box {
			height: calc(100vh - 604px);
			margin: 604px auto;
			padding-top: 60px;
			overflow-y: scroll;
			position: relative;

			.qdDataIconBox {
				.qdDataIconLeft {
					position: absolute;
					left: 20%;
					top: 20px;
					height: 60px;
					z-index: 100;
				}

				.qdDataIconRight {
					position: absolute;
					right: 20%;
					top: 20px;
					height: 60px;
					z-index: 100;
				}
			}

			// 日历
			.calendar {
				background: #FFF;
				position: relative;
				width: 90vw;
				margin: 0 auto;
				height: auto;
				border-radius: 15px;
				font-family: "PingFangSC-Regular";
				overflow: hidden;
				-webkit-box-shadow: 0 0 4px 0 rgba(37, 206, 222, .3);
				/*no*/
				-moz-box-shadow: 0 0 4px 0 rgba(37, 206, 222, .3);
				/*no*/
				box-shadow: 0 0 4px 0 rgba(37, 206, 222, .3);
				/*no*/

				.ym {
					// padding: 40px 20px 30px;
					height: 80px;
					line-height: 80px;
					font-size: 36px;
					text-align: center;
					display: flex;
					align-items: center;
					justify-content: space-between;
					position: relative;

					.prev img {
						width: 30px;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						left: 30%;
						transform: translateY(-50%);
					}

					.currentData {
						flex: 1;
						font-family: PingFangSC-Medium;
						font-size: 28px;
						/*px*/
						color: #1b1b1b;
					}

					.next img {
						width: 30px;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						right: 30%;
						transform: translateY(-50%);
					}
				}

				ul.thead {
					width: 100%;
					display: table;
					padding-bottom: 36px;

					li {
						width: 14.28%;
						height: 40px;
						text-align: center;
						font-size: 28px;
						float: left;
						font-family: PingFangSC-Regular;
						color: #888;

						span {
							font-size: 22px;
						}
					}
				}

				#data {
					margin-top: 0;
					overflow: hidden;

					li {
						width: 14.28%;
						height: 70px;
						text-align: center;
						float: left;
						z-index: 100;

						span {
							font-size: 28px;
							height: 28px;
							font-family: PingFangSC-Regular;
							color: #616161;
							border-radius: 50%;
							width: 70px;
							height: 70px;
							line-height: 70px;
							display: block;
							margin: 0 auto;
						}
						span.activeData{
							background: url(../../assets/img/dataActive.png) no-repeat 50% 50%;
							background-size: 100% 100%;
							color: #fff;
						}

						img {
							width: 32px;
							height: 32px;
							display: block;
							margin: 0 auto;
							background-size: cover;
						}

						span {
							font-size: 22px;
							display: block;
							color: #616161;
						}

						.pro {
							font-size: 22px;
							color: #616161;
							margin-top: 12px;
						}


					}

					li.active {
						color: #FD810B;

						span.pro {
							font-size: 22px;
							color: #FD810B;
							margin-top: 12px;
						}

						span.active {
							background: url(../../assets/img/dataActive.png) no-repeat center;
							background-size: 100% 100%;
							color: #fff;
						}
					}
				}
			}


		}

		//弹框
		.van-overlay {
			z-index: 120;
			background-color: rgba(74, 74, 74, .7);
		}

		.wrapper {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
		}

		.tostBox {
			background-color: #fff;
			width: 100vw;
			height: 100vh;
			background: url(../../assets/img/qiandaoTk.png) no-repeat 50% 50%;
			background-size: 85%;
			position: relative;

			.tostBox_info {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);

				h4 {
					line-height: 80px;
					font-size: 40px;
					/*px*/
					text-align: center;
					font-weight: 600;
					color: #14c2a9;
				}

				p {
					line-height: 40px;
					padding-left: 15px;
					padding-top: 20px;
					text-align: center;
					font-size: 26px;
					/*px*/
					color: #71d3c2;
				}
			}


		}
	}
</style>
